import { render } from "./IconRenault.vue?vue&type=template&id=1c9d67ff"
import script from "./IconRenault.vue?vue&type=script&lang=js"
export * from "./IconRenault.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__